import React from "react";
import BaseCard from "./BaseCard";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import moneyHelper from '../../../../Helpers/moneyHelper';

//ServiceTypeCode == 3 OID 8937 pdID 43955
class VideoCostsCard extends BaseCard {
  render() {
    const { Tier } = this.props;
    const enabled = parseInt(this.props.pricingDetail.ServiceTypeCode) === 3;

    return (
      <div className='card'>
        {this.renderCardHeader(enabled)}
        {this.state.bodyactive && enabled ? (
          <div>
            {this.renderNoteCard()}
            {this.renderHeaderDataTable()}
            {this.renderDataTableLengthOfEvaluation(Tier)}
            {this.renderDataTableEditor(Tier)}
            {this.renderDataTableTimeCapture(Tier)}
            {this.renderDataTableShippingHandling(Tier)}
            {this.renderDataTableCard(Tier)}
            {this.renderDataTableStreaming(Tier)}
            {this.renderDataTableCDR(Tier)}
            {this.renderDataTableDVD(Tier)}
            {this.renderDataTableSingleDouble(Tier)}
            {this.renderMailingToClient(Tier)}
            {this.renderDNETable(Tier)}
          </div>
        ) : null}
        {this.renderFooter(enabled, Tier)}
      </div>
    );
  }

  renderHeaderDataTable() {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInHeaderDataTable,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Header'
        smallDataTable={true}
        thereIsNoSuchRowMessageCheck={false}
      />
    );
  }

  renderDataTableLengthOfEvaluation(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableLengthOfEvaluation,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier.PricingDetails}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableEditor(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableEditor,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableTimeCapture(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableTimeCapture,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableShippingHandling(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableShippingHandling,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableCard(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableCard,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableStreaming(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableStreaming,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableCDR(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableCDR,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableDVD(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableDVD,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDataTableSingleDouble(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableSingleDouble,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderMailingToClient(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableMailingToClient,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderDNETable(Tier) {
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableDNE,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        itemList={Tier}
        renderInputFieldFunction={this.renderInputField}
        DataTableType='Body'
        smallDataTable={true}
      />
    );
  }

  renderFooter(enabled, Tier) {
    return enabled ? (
      <footer>
        <DataTable
          type={{
            FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
            NameOfTheIdField: () => 'TierId',
            FieldsToShowInListTable: [],
            MoneyFields: this.MoneyFields,
            Currency: this.Currency,
          }}
          headeritemList={Tier}
          thereIsNoSuchRowMessageCheck={false}
          smallDataTable={true}
        />
      </footer>
    ) : null;
  }

  renderCardHeader(enabled) {
    return (
      <CardHeader
        sectionNumber={'9'}
        HeaderText={'VIDEO COSTS (IF APPLICABLE)'}
        changeBodyStatus={this.changeBodyStatus}
        bodyactive={this.state.bodyactive && enabled}
        disabled={!enabled}
        subtotal={moneyHelper.toMoneyFormat(this.props.Tier.VideoCostTotal, this.props.Tier.PricingDetails.CurrencyCode)}
        subtotalRev={this.props.Tier.VideoCostPct + ' of revenue'}
      />
    );
  }

  renderNoteCard() {
    return (
      <NoteCard
        noteActive={this.state.noteActive}
        renderInputField={this.renderInputField}
        name='VideoCostsNotes'
        value={this.props.Tier.PricingDetails}
      />
    );
  }

  FieldsToShowInHeaderDataTable() {
    return [
      { label: ' ', tableminWidth: '375px' },
      { label: 'Per hour', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Per evaluation', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Per cycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: 'Annually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '% of revenues', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
  FieldsToShowInFooterDataTable() {
    return [
      { label: 'TOTAL VIDEO COST', tableminWidth: '750px', headerPosition: 'header-text-right' },
      { label: '', data: 'VideoCostTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'VideoCostPct', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
  FieldsToShowInDataTableLengthOfEvaluation() {
    return [
      { label: 'Length of evaluation (in hours)', type: FieldTypesEnum.JustLabel, data: '', tableminWidth: '375px' },
      {
        data: 'LengthVideoShopHours',
        type: InputTypesEnum.Text2,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }
  FieldsToShowInDataTableDNE() {
    return [
      { label: 'DNE', type: FieldTypesEnum.JustLabel, data: '', tableminWidth: '375px' },
      {
        label: ' ',
        type: FieldTypesEnum.EmptySpace,
        data: '',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: ' ',
        data: 'DNEPctConvText',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'DNECostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'DNECostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'DNECostPerPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableMailingToClient() {
    return [
      { label: 'Mailing to client (UPS)', type: FieldTypesEnum.JustLabel, data: '', tableminWidth: '375px' },
      { label: ' ', data: 'MailingCostPerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        type: FieldTypesEnum.EmptySpace,
        data: '',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'MailingCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'MailingCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'MailingCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableSingleDouble() {
    return [
      {
        label: ' ',
        data: 'Single_Double_Name',
        // type: FieldTypesEnum.JustLabel,
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '375px',
      },
      {
        label: ' ',
        data: 'VideoCaseTypeCode',
        type: InputTypesEnum.Select2,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
        selectValues: selectHelper.getSelectOptionsVideoCaseTypeCode(),
        fieldClass: '-', //this is a hack to remove the second border
      },
      {
        label: ' ',
        data: '',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'VideoCaseCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'VideoCaseCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'VideoCaseCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableDVD() {
    return [
      { data: 'DVDName', type: InputTypesEnum.TextReadOnly, tableminWidth: '375px' },
      {
        data: 'IsVideoDvd',
        type: InputTypesEnum.EmptyYesNoSelect2,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
        fieldClass: '-', //this is a hack to remove the second border
      },
      { data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        data: 'DVDCostPerCycle',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'DVDCostAnnually',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        data: 'DVDCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableCDR() {
    return [
      { label: ' ', data: 'CDRName', type: InputTypesEnum.TextReadOnly, tableminWidth: '375px' },
      {
        label: ' ',
        data: 'IsVideoCdr',
        type: InputTypesEnum.EmptyYesNoSelect2,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
        fieldClass: '-', //this is a hack to remove the second border
      },
      {
        label: ' ',
        data: '',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'CDRCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'CDRCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'CDRCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableStreaming() {
    return [
      { label: 'Streaming', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      { label: ' ', data: 'StreamingCostPerHourConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'StreamingCostPerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'StreamingCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'StreamingCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'StreamingCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInDataTableCard() {
    return [
      { label: 'Card', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      {
        label: ' ',
        data: '',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'CardCostPerEvalConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'CardCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'CardCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'CardCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableShippingHandling() {
    return [
      { label: 'Shipping/Handling', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      {
        label: ' ',
        data: '',
        type: FieldTypesEnum.EmptySpace,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: 'ShippingCostPerEvalConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'ShippingCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'ShippingCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'ShippingCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
  FieldsToShowInDataTableTimeCapture() {
    return [
      { label: 'Time Capture', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      { label: ' ', data: 'TimeCaptureCostPerHourConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'TimeCaptureCostPerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'TimeCaptureCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'TimeCaptureCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'TimeCaptureCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInDataTableEditor() {
    return [
      { label: 'Editor', data: '', type: FieldTypesEnum.JustLabel, tableminWidth: '375px' },
      { label: ' ', data: 'EditorCostPerHourConv', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'VideoEditorCostPerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'VideoEditorCostPerCycle', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: ' ', data: 'VideoEditorCostAnnually', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: ' ',
        data: 'VideoEditorCostPct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }
}

export default VideoCostsCard;
